import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Image, Text, Center, Flex } from '@chakra-ui/react';
import { tripadvisorAwardtype } from '@whitbread-eos/api';
import { ModalVariants } from '@whitbread-eos/atoms';
import { formatInnerHTMLAssetUrls, renderSanitizedHtml, useSemanticTypography } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { useState, createElement as _createElement } from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function TopRatingSection(_ref) {
  var _tripAdvisorData$awar;
  var tripAdvisorData = _ref.tripAdvisorData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var getTypographyProps = useSemanticTypography();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var defaultAwardModalInfo = {
    description: '',
    title: '',
    image: ''
  };
  var _useState3 = useState(defaultAwardModalInfo),
    _useState4 = _slicedToArray(_useState3, 2),
    awardModalData = _useState4[0],
    setAwardModalData = _useState4[1];
  if (!tripAdvisorData || !Object.keys(tripAdvisorData).length) {
    return null;
  }
  function toggleModal() {
    setIsModalOpen(!isModalOpen);
  }
  function awardModalClickHandler(award) {
    var _award$awardType, _award$awardType2, _award$year, _award$image;
    var selectedAwardType = ((_award$awardType = award.awardType) === null || _award$awardType === void 0 ? void 0 : _award$awardType.toLowerCase()) === 'travelers choice' ? tripadvisorAwardtype.CHOICE : tripadvisorAwardtype.BEST;
    setAwardModalData({
      description: formatInnerHTMLAssetUrls(t("tripadvisor.award.".concat(selectedAwardType, ".text"))),
      title: t('tripadvisor.award.title').replace('{award_name}', (_award$awardType2 = award.awardType) !== null && _award$awardType2 !== void 0 ? _award$awardType2 : '').replace('{award_year}', (_award$year = award.year) !== null && _award$year !== void 0 ? _award$year : ''),
      image: (_award$image = award.image) !== null && _award$image !== void 0 ? _award$image : ''
    });
    toggleModal();
  }
  var scrollToUserReviewSection = () => {
    var element = document.getElementById('tripadvisor-user-review-section');
    if (element) {
      element.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
    }
  };
  return _jsxs(Box, {
    "data-testid": "tripadvisor-top-rating-section-hdp",
    display: "flex",
    children: [tripAdvisorData !== null && tripAdvisorData !== void 0 && tripAdvisorData.rating && tripAdvisorData !== null && tripAdvisorData !== void 0 && tripAdvisorData.numberOfReviews ? _jsxs(Flex, {
      mb: "sm",
      children: [_jsx(Image, _objectSpread(_objectSpread({}, taImageStyles), {}, {
        src: "https://static.tacdn.com/img2/ratings/traveler/".concat((Math.round(tripAdvisorData.rating * 2) / 2).toFixed(1), ".svg"),
        alt: "ta-ratings-img"
      })), _jsx(Text, _objectSpread(_objectSpread(_objectSpread({
        as: "u"
      }, reviewsLayoutStyles), getTypographyProps(reviewsLegacyTypography, reviewsSemanticTypography)), {}, {
        onClick: scrollToUserReviewSection,
        children: "(".concat(tripAdvisorData.numberOfReviews, " ").concat(t('hoteldetails.tripadvisorreviews'), ")")
      }))]
    }) : _jsx(_Fragment, {}), tripAdvisorData === null || tripAdvisorData === void 0 || (_tripAdvisorData$awar = tripAdvisorData.awards) === null || _tripAdvisorData$awar === void 0 ? void 0 : _tripAdvisorData$awar.slice(0, 1).map(award => {
      var _award$awardType3;
      return _createElement(Image, _objectSpread(_objectSpread({
        src: award === null || award === void 0 ? void 0 : award.image,
        alt: award === null || award === void 0 ? void 0 : award.awardType,
        onClick: () => awardModalClickHandler(award),
        maxWidth: "32px",
        mt: "-3px"
      }, cursorStyle), {}, {
        ml: 3,
        key: award === null || award === void 0 || (_award$awardType3 = award.awardType) === null || _award$awardType3 === void 0 ? void 0 : _award$awardType3.toLowerCase(),
        "data-testid": "tripadvisor-top-rating-award-button"
      }));
    }), _jsx(ModalVariants, {
      onClose: toggleModal,
      isOpen: isModalOpen,
      variant: "info",
      children: _jsx(Box, _objectSpread(_objectSpread({}, modalStyles), {}, {
        children: _jsxs(Box, _objectSpread(_objectSpread({
          maxW: "full"
        }, containerStyles), {}, {
          children: [_jsx(Center, {
            children: _jsx(Image, _objectSpread(_objectSpread({
              src: awardModalData.image
            }, modalAwardIcon), {}, {
              "data-testid": "tripadvisor-modal-award-icon"
            }))
          }), _jsx(Text, {
            mt: "15px",
            mb: "15px",
            children: awardModalData.title
          }), _jsx(Box, {
            mt: 3,
            children: renderSanitizedHtml(awardModalData.description)
          })]
        }))
      }))
    })]
  });
}
var modalStyles = {
  w: {
    md: '35.125rem'
  },
  px: 'md',
  pb: 'lg'
};
var containerStyles = {
  mb: {
    base: 'lg',
    sm: '2xl'
  }
};
var cursorStyle = {
  cursor: 'pointer'
};
var reviewsLayoutStyles = _objectSpread({}, cursorStyle);
var reviewsLegacyTypography = {
  fontSize: 'sm',
  lineHeight: 'var(--chakra-sizes-6)'
};
var reviewsSemanticTypography = {
  textStyle: 'link-s-regular'
};
var modalAwardIcon = {
  w: '200px',
  h: '230px'
};
var taImageStyles = {
  h: '20px',
  ml: '-7px',
  mt: '3px'
};